import Delta from '@solimat/solimat-web-endpoint/lib/Delta';

const useValidatePat = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_DELTA_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_DELTA_KEY || "";
  const apiDelta = new Delta.Pat(BASE_URL, FUNCTIONS_KEY);
  
  const validatePat = async(Id:any)=> {
    try 
    {
      const response = await apiDelta.validatePAT(Id)
        return response.data;
    } 
    catch (err) {
      console.error(err);
      const status = (err as any)?.response?.status;
      if (status === 400 || status === 500) {
        return {
          errorInServer: true,
          status,
        };
      }
      return false;
    }

  }

  return {
    validatePat
  }

}

export default useValidatePat;
